export const urlConverter = (url: string) => {
  if (url && url.length > 8 && url.substring(0, 7) === 'http://') {
    return 'https://app.wubmal.com/api//' + url.substring(22, url.length);
  }
  return url;
};
